export enum AGE_ALLOW_TYPE {
  DT00= 'DT00',
  DT00_DT06= 'DT00_DT06',
  DT01= 'DT01',
  DT02= 'DT02',
  DT03= 'DT03',
  DT03_DT04= 'DT03_DT04',
  DT04= 'DT04',
  DT05= 'DT05',
  DT06= 'DT06',
  DT06_DT07= 'DT06_DT07',
  DT07= 'DT07',
  DT07_DT12= 'DT07_DT12',
  DT08= 'DT08',
  DT08_DT10= 'DT08_DT10',
  DT09= 'DT09',
  DT10= 'DT10',
  DT11= 'DT11',
  DT12= 'DT12',
  DT12_DT15= 'DT12_DT15',
  DT13= 'DT13',
  DT13_DT14= 'DT13_DT14',
  DT14= 'DT14',
  DT15= 'DT15',
}